import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AllEvents from "../components/Admin/AllEvents";

const AdminDashboardEvents = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={6} />
          </div>
          <div className="admin-dashboard-main admin-dashboard-events-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin Events</p>
                <h1>All Events</h1>
                <p className="admin-page-copy">Audit platform events, timing, visibility, and marketplace activity in a consistent admin view.</p>
              </div>
            </header>
            <AllEvents />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardEvents;
